import {
  EMPTY_GFE_FILTERS,
  GfeActiveModal,
  GfeFilters,
  GfeSelectedRow,
} from "../../types/gfe_types";
import { GfeAction, GfeActionType } from "../gfe_actions";

export type GfeState = {
  filters: GfeFilters;
  pageNumber: number;
  pageSize: number;
  /** One discriminated value rather than a boolean per modal, so two can never be open at once. */
  activeModal: GfeActiveModal;
  selectedRow: GfeSelectedRow | null;
  error: string | undefined;
};

export const INITIAL_GFE_STATE: GfeState = {
  filters: EMPTY_GFE_FILTERS,
  pageNumber: 1,
  pageSize: 10,
  activeModal: null,
  selectedRow: null,
  error: undefined,
};

export function gfeReducer(state: GfeState, action: GfeAction): GfeState {
  switch (action.type) {
    case GfeActionType.SET_FILTER:
      // Any filter change resets to the first page: staying on page 4 of a narrower result set shows
      // an empty grid that reads as "no matches".
      return { ...state, filters: { ...state.filters, ...action.payload }, pageNumber: 1 };

    case GfeActionType.RESET_FILTERS:
      return { ...state, filters: EMPTY_GFE_FILTERS, pageNumber: 1 };

    case GfeActionType.SET_PAGE:
      return { ...state, pageNumber: action.payload };

    case GfeActionType.SET_PAGE_SIZE:
      return { ...state, pageSize: action.payload, pageNumber: 1 };

    case GfeActionType.OPEN_EDIT:
      return { ...state, activeModal: "edit", selectedRow: action.payload, error: undefined };

    case GfeActionType.OPEN_DELETE:
      return { ...state, activeModal: "delete", selectedRow: action.payload, error: undefined };

    case GfeActionType.CLOSE_MODAL:
      return { ...state, activeModal: null, selectedRow: null, error: undefined };

    case GfeActionType.SET_ERROR:
      return { ...state, error: action.payload };

    default:
      return state;
  }
}
